import * as React from 'react';

import { concatStyleSets } from '@fluentui/react';

import { AppSpinButton, AppSpinButtonInternalProps } from '@1js/acui-button';
import { getModernUxExperimentPreference } from '@1js/acui-common';

import { getModernUxRibbonSpinButtonStyles } from '../../../../styling/modernUxStyles';
import { RibbonControlInternalProps } from '../RibbonControlProps';

export type RibbonSpinButtonInternalProps = AppSpinButtonInternalProps & RibbonControlInternalProps;

export class RibbonSpinButton extends React.PureComponent<RibbonSpinButtonInternalProps, {}> {
  public render() {
    const styles = getModernUxExperimentPreference()
      ? concatStyleSets(this.props.styles, getModernUxRibbonSpinButtonStyles())
      : this.props.styles;
    return <AppSpinButton {...this.props} styles={styles} />;
  }
}
